import React from "react";
import { ResponsiveLine } from "@nivo/line";
import { hexColorRegex } from "validations/matchers";
import { ILineChartData } from "./LineChartInterfaces";
import moment from "moment";

export const LineChart = ({ data }: ILineChartData) => {
    const colors: string[] = [];

    data.forEach((dataItem) => {
        return Object.values(dataItem).forEach((value) => {
            if (typeof value === "string" && hexColorRegex.test(value) && !colors.includes(value)) {
                colors.push(value);
            }
        });
    });

    const xTickFormat = (value: string) => {
        const date = new Date(value);
        return moment(date).format("YYYY-MM-DD") === "Invalid date" ? "" : moment(date).format("YYYY-MM-DD");
    };

    const chartTheme = {
        axis: {
            fontSize: "10px",
            tickColor: "#2B2E3D",
            ticks: {
                text: {
                    fill: "#2B2E3D",
                    fontFamily: "Open Sans",
                    fontSize: "10px",
                },
            },
        },
    };

    return (
        <ResponsiveLine
            colors={colors}
            theme={chartTheme}
            key="lines"
            data={data}
            margin={{ top: 20, right: 20, bottom: 50, left: 60 }}
            xScale={{ type: "point" }}
            yScale={{
                type: "linear",
                min: "auto",
                max: "auto",
                stacked: false,
                reverse: false,
            }}
            axisTop={null}
            axisRight={null}
            axisBottom={{
                tickSize: 5,
                tickPadding: 5,
                tickRotation: -45,
                format: xTickFormat,
            }}
            axisLeft={{
                tickSize: 5,
                tickRotation: 0,
            }}
            enableGridX={false}
            lineWidth={3}
            enablePoints={false}
            pointSize={10}
            pointColor={{ theme: "background" }}
            pointBorderWidth={2}
            pointBorderColor={{ from: "serieColor" }}
            pointLabelYOffset={-12}
            useMesh={true}
            legends={[]}
        />
    );
};
